<template lang="pug">
div
  template(v-if="!pagesStore.edit")
    table.table.table-striped
      thead
        tr
          th Title
          th Slug
          th Notes
          th Stories
      tbody
        tr(v-for="page in pages")
          td
            router-link(:to="`/issues/${issueId}/pages/${page.id}`")
              | {{ page.title }}
          td {{ page.slug }}
          td {{ page.notes }}
          td {{ page.story_count }}

    .row
      .col-md-12.text-right
        button.btn.btn-default(v-on:click="pagesStore.edit = true")
          i.fa.fa-pencil
          |
          | Edit Pages

  template(v-if="pagesStore.edit")
    IssuePagesForm(:issue-id="issueId")
</template>

<script>
  import { mapStores } from 'pinia'
  import { usePagesStore } from '@/stores/pages'

  import IssuePagesForm from './form.vue'

  export default {
    components: {
      IssuePagesForm
    },

    props: {
      issueId: {
        type: Number,
        required: true
      }
    },

    computed: {
      ...mapStores(usePagesStore),
      pages() { return this.pagesStore.forIssue({ id: this.issueId }) },
    },

    created() {
      this.pagesStore.fetch({ issueId: this.issueId })
    }
  }
</script>
